import ENVIRONMENT from '@/environments/environment';

import {
  OcrAPIData, OcrAPIRequest, OcrNfcApiData, OcrNfcRequest,
  OcrPostInvoice,
  PostInvoice,
} from '../../interfaces/OcrInterface/OcrInterface';
import Api from '../../utils/apiHelper';
import { allResponse } from '../operation/operationsInterface';
import { InvoiceData } from '../invoiceManaged/invoiceManagedInterface';

const OcrAPI = {
  postOcr: async (data: OcrAPIRequest | OcrPostInvoice): Promise<allResponse<OcrAPIData >> => {
    const URL = ENVIRONMENT.URL_API_OCR + ENVIRONMENT.URL_API_OCR_APIS.OCR_MAIN;
    const response = await Api.POST(URL, data);
    return response;
  },
  postOcrNfc: async (ocrdId: string, data: OcrNfcRequest): Promise<allResponse<OcrNfcApiData>> => {
    const URL = ENVIRONMENT.URL_API_OCR + ENVIRONMENT.URL_API_OCR_APIS.OCR_NFC;
    const formattedUrl = URL.replace('<ocrDocumentId>', ocrdId);
    const response = await Api.POST(formattedUrl, data);
    return response;
  },
  postOcrAnalyze: async (ocrdId: string, data: PostInvoice): Promise<allResponse<InvoiceData>> => {
    const URL = ENVIRONMENT.URL_API_OCR + ENVIRONMENT.URL_API_OCR_APIS.OCR_ANALYZE;
    const formattedUrl = URL.replace('<ocrDocumentId>', ocrdId);
    const response = await Api.POST(formattedUrl, data);
    //id del documento
    response.data.third_party_response.invoice_id = ocrdId;
    return response;
  }
};

export const { postOcr, postOcrNfc, postOcrAnalyze } = OcrAPI;
